import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from '../../../environments/environment';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { IUserDetails } from '../search/typings';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private userDetails: any;

  constructor(private http: HttpClient) { }

  getUseDetails(): Observable<IUserDetails> {      
    return this.http.get<IUserDetails>(env.API.userInfo_url).pipe(
      tap(userDetails => this.setUserDetails(userDetails)),
      catchError(error => {
        console.error('Error fetching user details:', error);
        return throwError(() => error);
      })
    );
  }

  setUserDetails(userDetails: IUserDetails): void {
    this.userDetails = userDetails;
  }

  getUserDetailsAfterLogin() {
    return this.userDetails;
  }

  verifyContentEditAccess(): Observable<boolean> {
    return this.getUseDetails().pipe(
      map(userDetails => {
        if (Array.isArray(userDetails) && userDetails.length > 0) {
          return !!userDetails[0]?.hasContentEditAccess;
        }
        return !!userDetails?.hasContentEditAccess;
      }),
      catchError(() => of(false))
    );
  }
}
